import { render, staticRenderFns } from "./FootContent.vue?vue&type=template&id=c0d5d44c&"
import script from "./FootContent.vue?vue&type=script&lang=js&"
export * from "./FootContent.vue?vue&type=script&lang=js&"
import style0 from "./FootContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports